// extracted by mini-css-extract-plugin
export default {"page":"Layout_page__ulGah","root":"Layout_root__oCzRO","main-container":"Layout_main-container__2Vj1J","home-container":"Layout_home-container__EIQsD"};